import React, { useEffect, useRef, useState } from "react";
import {
  /* … */
  FormControl,
  InputLabel,
  Select /* … */,
} from "@mui/material";
import "../DashboardCards/DashboardsCards.css";
// import { FaHeart } from "react-icons/fa";
import { IoLocation } from "react-icons/io5";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import PaymentGateway from "../PaymentGeteway/PaymentGateway";
import noimage from "../../Assets/noimage.jpg";
import { useNavigate } from "react-router-dom";

import Loader from "../Loader/Loader";
import { Modal, Box, Button, TextField, MenuItem } from "@mui/material";
import { IoClose } from "react-icons/io5";
import { APIUrl, APIUrlToken, getIsUser } from "../../Utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";
import { FaHeart } from "react-icons/fa";
import { useAuth0 } from "@auth0/auth0-react";
import { NilCollaborationForm } from "../NilCollaborationForm/NilCollaborationForm";

const DashboardsCards = ({
  handleViewDetail,
  handleViewFanEngagement,
  handleViewBrandEngagement,
  apiCalled,
  playersCount,
  loading,
  players,
  setLoading,
  handleNextClick,
  open,
  setOpen,
  showContribute = true, // NEW
  showCollab = true,
  mode,
}) => {
  const navigate = useNavigate();

  const userLoginDetails = getIsUser();
  const { loginWithRedirect } = useAuth0();
  const [openRequest, setOpenRequest] = useState();
  const [serviceType, setServiceType] = useState("general_contribution");
  const handleLoginIn = async () => {
    await loginWithRedirect({
      appState: {
        returnTo: "/",
      },
    });
  };
  const [formData, setFormData] = useState({
    player_id: 0,
    playerName: "",
    team_id: 0, // --> NEW
    donateAmount: 0,
    teamName: "",
    transferredFrom: 0,
    transferedTeamName: "",
    transferredTo: 0,
    paymentDetails: "",
  });
  const [favoriteList, setFavoriteList] = useState([]);

  const handleOpenModal = (player, key) => {
    setFormData({
      ...formData,
      player_id: player.player_id,
      playerName: player.player_name,
      team_id: player.team_id, // ← add this NEW
      teamName: player.team_name,
      transferredFrom: player?.team_id,
    });
    setOpen(true);
    // setPayKey(key)
  };
  const handleOpenModalRequest = (player) => {
    setOpenRequest(player);
  };

  const getBgClass = (donations) => {
    if (donations < 100) return "bg-red";
    if (donations < 500) return "bg-yellow";
    if (donations < 1000) return "bg-green";
    if (donations < 5000) return "bg-blue";
    return "bg-purple";
  };
  const [openSection, setOpenSection] = useState("one-time");

  const [oneTimeAmount, setOneTimeAmount] = useState(0);

  const [oneTimeOther, setOneTimeOther] = useState("");
  const durations = [
    { label: "3 Months", value: 3 },
    { label: "6 Months", value: 6 },
    { label: "12 Months", value: 12 },
  ];
  const toggleSection = (section) => {
    setOpenSection(openSection === section ? "" : section);
  };
  const handleDonationOnetime = () => {
    if (!oneTimeAmount) {
      toast.error("Please select or add donation amount.");
      return;
    }
    if (!serviceType) {
      toast.error("Please choose a NIL Service Type.");
      return;
    }
    let data = {
      amount: Number(oneTimeAmount),
      nil_service_type: serviceType,
      player_id: Number(formData?.player_id),
      player_name: formData?.playerName,
      team_id: Number(formData.transferredFrom), // ← include team_id here
    };
    if (userLoginDetails?.user_id) {
      data.user_id = userLoginDetails?.user_id;
      data.user_email = userLoginDetails?.user_email;
    }

    const url = `${APIUrl()}/v1/create-checkout-session/one_time`;
    const option = {
      method: "POST",
      headers: {
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: url,
    };

    axios(option)
      .then((response) => {
        const checkoutUrl = response?.data?.checkout_url;
        if (!checkoutUrl) {
          toast.error("Could not start checkout. Please try again.");
          return;
        }
        window.open(checkoutUrl, "_blank");
      })
      .catch((error) => {
        console.error("One-time checkout failed:", error);
        toast.error(
          error?.response?.data?.detail ||
            "Could not start checkout. Please try again."
        );
      });
  };
  const saveFavoritePlayer = (item) => {
    if (!userLoginDetails) {
      handleLoginIn();
    }

    let data = {
      user_id: userLoginDetails?.user_id,
      player_id: item?.player_id,
      brand_favourite: mode === "collab" ? true : false,
      fan_favourite: mode === "contribute" ? true : false,
    };

    const url = `${APIUrl()}/v1/save_favourite_player`;
    const option = {
      method: "POST",
      headers: {
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: url,
    };

    axios(option)
      .then((response) => {
        toast.success("Player added to Favorites");
        listFavoritePlayers();
      })
      .catch((error) => {
        console.error("Error", error);
      });
  };
  const saveUnFavoritePlayer = (player) => {
    if (!userLoginDetails) {
      toast.error("Please sign-up for a free account to access this feature");
      return;
    }
    const id = favoriteList?.find(
      (item) => item?.player_id === player?.player_id
    );
    const url = `${APIUrl()}/v1/v1/remove_favourite_player?id=${
      id?.favourites_id
    }`;
    const option = {
      method: "POST",
      headers: {
        "X-API-Key": APIUrlToken(),
      },
      url: url,
    };

    axios(option)
      .then((response) => {
        toast.success("Player removed from Favorites");
        listFavoritePlayers();
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const listFavoritePlayers = () => {
    const url = `${APIUrl()}/v1/v1/list_favourite_players?userid=${
      userLoginDetails?.user_id
    }&limit=500`;
    const option = {
      method: "POST",
      headers: {
        "X-API-Key": APIUrlToken(),
      },
      url: url,
    };

    axios(option)
      .then((response) => {
        setFavoriteList(response?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  useEffect(() => {
    if (userLoginDetails?.user_id) {
      listFavoritePlayers();
    }
  }, [userLoginDetails?.user_id]);
  return (
    <>
      {loading ? <Loader /> : null}
      <div className="main-filter-DashboardsCards">
        {players?.length ? (
          <div className="card-outer-Container">
            <div className="card-inner-Container">
              {players?.map((player, index) => (
                <div className="cards-box-dash" key={index}>
                  <div className="product-image">
                    <span className="tagtext banner0"></span>
                    {mode === "contribute" ? (
                      favoriteList?.some(
                        (item) =>
                          item?.player_id === player?.player_id &&
                          item?.fan_favourite === true
                      ) ? (
                        <span
                          className="fa-nil-red"
                          onClick={() => saveUnFavoritePlayer(player)}
                        >
                          <FaHeart className="fa-red" />
                        </span>
                      ) : (
                        <span
                          className="fa-nil-white"
                          onClick={() => saveFavoritePlayer(player)}
                        >
                          <FaHeart className="fa-white" />
                        </span>
                      )
                    ) : favoriteList?.some(
                        (item) =>
                          item?.player_id === player?.player_id &&
                          item?.brand_favourite === true
                      ) ? (
                      <span
                        className="fa-nil-red"
                        onClick={() => saveUnFavoritePlayer(player)}
                      >
                        <FaHeart className="fa-red" />
                      </span>
                    ) : (
                      <span
                        className="fa-nil-white"
                        onClick={() => saveFavoritePlayer(player)}
                      >
                        <FaHeart className="fa-white" />
                      </span>
                    )}

                    {/* The "Pending Transfer" badge is gone: pending_transfer
                        no longer exists. A transfer is simply the athlete's
                        team_id moving, so there is no interim state to show. */}
                    {/* <span className="savebkmrk" id="favoritebtn0">
                        ${player?.received_donations}
                      </span> */}
                    <img
                      src={player?.image_url ? player?.image_url : noimage}
                      alt="Business"
                      onError={(e) => {
                        e.target.src = noimage;
                      }}
                    />
                  </div>
                  <div className="title-cards">
                    <h5>{player?.player_name}</h5>
                  </div>
                  {/* <div className="location-card-dash">
                    <div className="dc-donate">
                      <IoLocation />
                      <p>{player?.birthplace}</p>
                    </div>
                    <p className={`donation_card_rece ${getBgClass(player?.received_donations)}`}>
                      $ {player?.received_donations}
                    </p>
                  </div> */}
                  <div className="listingid-dash">
                    <b>Team:</b>
                    <p className="listingid-numbs">
                      {player?.team_name ? player?.team_name : "-"}
                    </p>
                  </div>
                  <div className="listingid-dash">
                    <b>Class:</b>
                    <p className="listingid-numbs">
                      {player?.player_class ? player?.player_class : "-"}
                    </p>
                  </div>
                  <div className="dis-height-weight">
                    <div className="listingid-dash">
                      <b>Position:</b>
                      <p className="listingid-numbs">
                        {player?.position ? player?.position : "-"} #{" "}
                        {player?.jersey_number
                          ? Math.round(player?.jersey_number)
                          : "-"}
                      </p>
                    </div>
                    {/* <div className="listingid-dash">
                        <b>Donations:</b>
                        <p className="listingid-numbs donation_card_rece">$ {player?.received_donations}</p>
                      </div> */}
                  </div>
                  <div className="dis-height-weight">
                    <div className="business-price-dash">
                      <b>Height:</b>
                      <p className="business-price-numbs">
                        {player?.height ? player?.height : "-"}
                      </p>
                    </div>
                    <div className="business-price-dash">
                      {player?.weight ? <b>Weight:</b> : null}
                      <p className="business-price-numbs">
                        {player?.weight ? player?.weight : ""}
                      </p>
                    </div>
                  </div>

                  {/* <div className="view-details-dash">
                      <b>View Details:</b>
                      <p onClick={() => handleViewDetail(player)}>Click here</p>
                    </div> */}
                  {/* <p onClick={() => navigate(`/players/${player.player_id}/${player.team_id}`)}>Click here</p> */}
                  {/* <div className="view-details-dash">
                      <b>Donate:</b>
                      <p onClick={() => handleOpenModal(player, 'donate')}>Click here</p>
                    </div> */}
                  {/* <div className="find-partner-btn ">
                      <button className="btn-collab" onClick={() => handleOpenModalRequest(player)}>NIL Collaboration Request</button>
                      <button onClick={() => handleOpenModal(player, 'donate')}>Contribute Now</button>
                    </div> */}
                  {/* <div className="find-partner-btn">
                      {showCollab && (
                        <button className="btn-collab" onClick={() => handleOpenModalRequest(player)}>
                          NIL Collaboration Request
                        </button>
                      )}
                      {showContribute && (
                        <button onClick={() => handleOpenModal(player, 'donate')}>
                          Contribute Now
                        </button>
                      )}
                    </div> */}
                  {mode === "contribute" ? (
                    <div
                      className="find-partner-btn"
                      style={{ marginTop: "10px" }}
                    >
                      <button
                        onClick={() => handleViewFanEngagement(player)}
                        // onClick={() => navigate("/FanExperience")}
                      >
                        {" "}
                        Start Your Fan Experience
                      </button>{" "}
                    </div>
                  ) : (
                    <div
                      className="find-partner-btn"
                      style={{ marginTop: "10px" }}
                    >
                      <button
                        // onClick={() => navigate("/BrandPartnership")}
                        onClick={() => handleViewBrandEngagement(player)}
                      >
                        {" "}
                        Start Your Brand Partnership
                      </button>{" "}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="no_results">
            {!loading && apiCalled && !players?.length
              ? "No Results found."
              : null}
          </div>
        )}
        {!loading && players?.length ? (
          <div className="prev-next-container">
            {playersCount === players?.length ? null : (
              <p className="next-btn-dash" onClick={handleNextClick}>
                Load More
              </p>
            )}
          </div>
        ) : null}
      </div>

      {/* <Modal open={open} onClose={() => setOpen(false)}> */}
      {showContribute && (
        <Modal open={open} onClose={() => setOpen(false)}>
          <div className="modal-container">
            <Box
              sx={{
                width: 700,
                p: 3,
                bgcolor: "white",
                borderRadius: 2,
                position: "relative",
              }}
            >
              <IoClose
                className="close-icon"
                size={24}
                onClick={() => setOpen(false)}
                style={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  cursor: "pointer",
                }}
              />
              <h3>
                Contribution for{" "}
                <span className="color-dc">{formData.playerName}</span> (
                {formData.teamName})
              </h3>
              {/* <div>Athletes may voluntarily participate in promotional activities associated with specific contributions. These activities may include, 
              but are not limited to, fan engagement opportunities such as meet-and-greets, social media interactions, access to exclusive content, 
              personalized merchandise, fan club participation, appearances at charity events, or virtual experiences. Participation in any such activity 
              in connection with a contribution shall be at the sole discretion of the athlete.</div> */}

              <div className="donation-container">
                <div className="accordion">
                  <div
                    className="accordion-header"
                    onClick={() => toggleSection("one-time")}
                  >
                    <strong>One-Time Contribution</strong>
                    <span>{openSection === "one-time" ? "▼" : "▶"}</span>
                  </div>
                  <div
                    className={`accordion-content ${
                      openSection === "one-time" ? "open" : ""
                    }`}
                  >
                    <div className="donation-options">
                      <button
                        className={oneTimeOther === "10" ? "selected" : ""}
                        onClick={() => {
                          setOneTimeAmount(10);
                          setOneTimeOther("10");
                        }}
                      >
                        $10
                      </button>
                      <button
                        className={oneTimeOther === "20" ? "selected" : ""}
                        onClick={() => {
                          setOneTimeAmount(20);
                          setOneTimeOther("20");
                        }}
                      >
                        $20
                      </button>
                      <button
                        className={oneTimeOther === "50" ? "selected" : ""}
                        onClick={() => {
                          setOneTimeAmount(50);
                          setOneTimeOther("50");
                        }}
                      >
                        $50
                      </button>
                      <button
                        className={oneTimeOther === "100" ? "selected" : ""}
                        onClick={() => {
                          setOneTimeAmount(100);
                          setOneTimeOther("100");
                        }}
                      >
                        $100
                      </button>
                      <button
                        className={oneTimeOther === "500" ? "selected" : ""}
                        onClick={() => {
                          setOneTimeAmount(500);
                          setOneTimeOther("500");
                        }}
                      >
                        $500
                      </button>
                      <button
                        className={oneTimeOther === "1000" ? "selected" : ""}
                        onClick={() => {
                          setOneTimeAmount(1000);
                          setOneTimeOther("1000");
                        }}
                      >
                        $1000
                      </button>
                      <button
                        className={oneTimeOther === "other" ? "selected" : ""}
                        onClick={() => {
                          setOneTimeOther("other");
                          setOneTimeAmount();
                        }}
                      >
                        Other
                      </button>
                      {oneTimeOther === "other" ? (
                        <TextField
                          label="Contribution Amount"
                          name="donateAmount"
                          fullWidth
                          margin="normal"
                          type="number"
                          //   onChange={(e) => setOneTimeAmount(e.target.value)}
                          // />
                          //
                          onChange={(e) => {
                            const val = parseInt(e.target.value, 10);
                            // clamp: never set a negative value
                            setOneTimeAmount(val < 0 ? 0 : val);
                          }}
                          value={oneTimeAmount}
                        />
                      ) : null}
                      <FormControl fullWidth margin="normal">
                        <InputLabel id="service-type-label">
                          NIL Service Type
                        </InputLabel>
                        <Select
                          labelId="service-type-label"
                          id="service-type"
                          value="general_contribution"
                          label="NIL Service Type"
                          disabled
                          IconComponent={() => null} // ← this removes the arrow
                        >
                          <MenuItem value="general_contribution">
                            General Contribution
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <button
                      className="donate-btn"
                      onClick={handleDonationOnetime}
                    >
                      Make One-Time Contribution
                    </button>
                  </div>
                </div>

              </div>
            </Box>
          </div>
        </Modal>
      )}

      {/* <NilCollaborationForm openRequest={openRequest} setOpenRequest={setOpenRequest} />
       */}
      {showCollab && (
        <NilCollaborationForm
          openRequest={openRequest}
          setOpenRequest={setOpenRequest}
        />
      )}
    </>
  );
};
export default DashboardsCards;
